import { Action, ActionTree, ActionContext } from 'vuex'

import {
  SEND_LOGIN_REQUEST,
  FETCH_CUSTOMERS,
  STORE_SELECTED_CUSTOMER,
  CLEAR_AUTH_DATA
} from '@/system/store/action-types'
import {
  SET_AUTH,
  SET_CUSTOMERS_LIST,
  SET_CUSTOMER,
  CLEAR_AUTH
} from '@/system/store/mutation-types'
import { GET_AUTH } from '@/system/store/getter-types'
import {
  IAuthStore,
  ICredentials,
  ICustomer
} from '@/features/auth/store'
import AuthService from '@/features/auth/auth.service'

const sendLoginRequest: Action<IAuthStore, any> = async (
  context: ActionContext<IAuthStore, any>,
  credentials: ICredentials
) => {
  const authService = new AuthService()

  const auth = await authService.authorise(credentials)
  const user = await authService.getAuthUser(auth.token)

  return context.commit(SET_AUTH, { ...auth, user })
}

const setCustomers: Action<IAuthStore, any> = async (
  context: ActionContext<IAuthStore, any>,
  { customers }
) => {
  return context.commit(SET_CUSTOMERS_LIST, customers)
}

const storeCustomer: Action<IAuthStore, any> = async (
  context: ActionContext<IAuthStore, any>,
  customer: ICustomer
) => context.commit(SET_CUSTOMER, customer)

const clearAuthData: Action<IAuthStore, any> = (context: ActionContext<IAuthStore, any>) => {
  return context.commit(CLEAR_AUTH)
}

const actions: ActionTree<IAuthStore, any> = {
  [SEND_LOGIN_REQUEST]: sendLoginRequest,
  [SET_CUSTOMERS_LIST]: setCustomers,
  [STORE_SELECTED_CUSTOMER]: storeCustomer,
  [CLEAR_AUTH_DATA]: clearAuthData
}

export default actions
